// export const BaseURL = "http://localhost:3002";
// Set REACT_APP_API_URL (e.g. http://localhost:3002) to use another backend
export const BaseURL = process.env.REACT_APP_API_URL || "https://api.sapphirenuts.in";

// Read the body once: JSON if possible, otherwise plain text
const readBody = async (response) => {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch (e) {
    return text;
  }
};

// Shared response handling. Only 401/403 mean the login is gone;
// other errors (400, 404, 500) are returned so the page can show a message.
const handleResponse = async (response, failMessage) => {
  const result = await readBody(response);
  const tokenInvalid = typeof result === "string" && result.includes("Token is not valid");

  if (response.status === 401 || response.status === 403 || tokenInvalid) {
    window.dispatchEvent(new CustomEvent("authExpired"));
    return typeof result === "string" ? result : { ...result, success: false };
  }
  if (!response.ok) {
    if (result && typeof result === "object") {
      return { ...result, success: false, message: result.message || result.error || `${failMessage} ${response.status}` };
    }
    return { success: false, message: result || `${failMessage} ${response.status}` };
  }
  return result;
};

const request = async (method, url, { body, contentType } = {}, failMessage = "Request failed") => {
  const headers = {};
  if (contentType) headers["Content-Type"] = contentType;
  try {
    const response = await fetch(`${BaseURL}/${url}`, {
      method,
      credentials: "include",
      headers,
      body,
    });
    return await handleResponse(response, failMessage);
  } catch (e) {
    console.error(e);
    return { success: false, message: "Network error, please check your connection" };
  }
};

// formData = { data, contanttype } ; contanttype is optional (FormData uploads)
const postData = (url, formData = {}) =>
  request("POST", url, { body: formData.data, contentType: formData.contanttype });

const putData = (url, formData = {}) =>
  request("PUT", url, { body: formData.data, contentType: formData.contanttype }, "Update failed");

const putData2 = (url, formData = {}) =>
  request("PUT", url, { body: formData.data, contentType: "application/json" }, "Update failed");

const getData = (path) => request("GET", path, { contentType: "application/json" });

const DeleteData = (url) => request("DELETE", url, { contentType: "application/json" }, "Delete failed");

export { postData, getData, DeleteData, putData, putData2 };
